export default "__VITE_ASSET__f8afd2da__"